import type { MatchScreenDatasetAttributes } from '../context/MatchScreenContext'

/**
 * Parses the match-screen `data-*` attributes off the root element into the
 * typed attribute bag the app consumes.
 *
 * Note the casing: the backend emits the self-scheduling flag all-lowercase
 * (`data-selfschedulingenabled`), so it maps to the lowercase `dataset` key, not
 * the camelCased `selfSchedulingEnabled` a `data-self-scheduling-enabled` attribute
 * would produce. Reading the wrong key silently yields `undefined` and disables
 * self-scheduling (FSM-1141).
 */
export const readMatchScreenDatasetAttributes = (
  rootElement: HTMLElement
): MatchScreenDatasetAttributes => ({
  sessionUUID: rootElement.dataset?.sessionUuid || '',
  revisit: rootElement.dataset?.revisit === 'true',
  selfSchedulingEnabled: rootElement.dataset?.selfschedulingenabled === 'true',
  // Emitted only by the admin advisor-preview route; absent on live
  // match screens, so this must stay false-safe.
  isPreview: rootElement.dataset?.preview === 'true'
})
